import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const checkAvailabilityComponent = Loadable(() => import('../../../components/Combo'));
export default MapTo('vcg/components/soe-home/react/combo/CheckAvailability')(checkAvailabilityComponent);
